import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type Employee from 'modules/employees/store/models/Employee'

/**
 * Hook to get unique legal entities from a list of employees
 * @param employees List of employees to extract legal entities from
 * @returns Array of unique legal entities
 */
const useLegalEntitiesFromEmployees = (employees: Employee[]): LegalEntity[] => {
  // Get all legal entities
  const legalEntities = employees.map((employee) => employeeLegalEntity(employee))

  // Remove duplicates by ID
  const uniqueLegalEntities = legalEntities.reduce<LegalEntity[]>((acc, current) => {
    const exists = acc.find((item) => item.attributes.id === current.attributes.id)
    if (!exists) {
      acc.push(current)
    }
    return acc
  }, [])

  return uniqueLegalEntities
}

export default useLegalEntitiesFromEmployees
